module.exports = __webpack_public_path__ + "img/approve-list22.55e7b7e8.png";